<style>
/* .table-responsive,
.dataTables_scrollBody {
    overflow: visible !important;
} */
/* div.dataTables_scrollBody.dropdown-visible {
  overflow: visible !important;
} */

/* table .dropdown-menu {
    position: fixed !important;
    top: 50% !important;
    left: 92% !important;
    transform: translate(-92%, -50%) !important;
} */

/* .dataTables_scrollHead{
    position: static !important;
} */
.badgeku {
  background-color: red;
  color: white;
  font-size: 10px;
  padding: 1px 6px;
  text-align: center;
  border-radius: 5px;
}

#nonberusahaPICUPT_info,
#nonberusahaPICUPT_paginate,
#nonberusahaPICUPT_filter {
  display: none;
}
</style>
<template>
  <div>
    <div v-if="show" :show="show" class="text-center">
      <img :src="require('@/assets/loadingfish.gif')" alt="Loading..." width="150px" />
      <p id="cancel-label">Sedang memuat data...</p>

    </div>
    <div v-if="!show">
      <div class="d-flex justify-content-between">
        <div>
          <button type="button" class="btn btn-success" @click="exportData">
            <i class="fa fa-file-text-o"></i> Excel
          </button>
        </div>
        <div class="d-flex">
          <div class="d-flex">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mr-2 mb-0">Search: </label>
              <input v-model="search.value" type="text" class="form-control" id="search">
            </div>
            <div>
              <select v-model="search.field" class="form-control">
                <option value="nomor_permohonan">Nomor Pemohon</option>
                <option value="instansi_pemohon">Instansi Pemohon</option>
                <option value="jenis_kegiatan">Jenis Kegiatan</option>
                <option value="nama_perairan">Nama Perairan</option>
                <option value="provinsi">Provinsi</option>
                <!-- <option value="status_verdok">Status Verdok</option> -->
                <option value="status_permohonan">Status Permohonan</option>
                <option value="keterangan_status">Keterangan Status</option>
                <option value="tanggal_permohonan">Tgl. Permohonan</option>
                <option value="tanggal_lolos_verifikasi_administrasi">Tgl. Verdok</option>
                <option value="pic_name">PIC Pentek</option>
              </select>
            </div>
          </div>
          <div class="d-flex ml-4">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mb-0">Sort By: </label>
            </div>
            <div>
              <select v-model="sort.field" class="form-control">
                <option value="createdAt">Tgl. Dibuat</option>
                <option value="tanggal_permohonan">Tgl. Permohonan</option>
                <option value="tanggal_lolos_verifikasi_administrasi">Tgl. Verdok</option>
              </select>
            </div>
            <div class="ml-2">
              <select v-model="sort.direction" class="form-control">
                <option value="DESC">DESC</option>
                <option value="ASC">ASC</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table id="nonberusahaPICUPT" class="table" style="width: 100%">
          <thead>
            <tr>
              <th class="all">No</th>
              <th class="all">Nomor Pemohon</th>
              <th>Instansi Pemohon</th>
              <th class="all">Jenis Kegiatan</th>
              <th class="all">Nama Perairan</th>
              <th class="all">Provinsi</th>
              <!-- <th>Status Verdok</th> -->
              <th>Status Permohonan</th>
              <th>Keterangan Status</th>
              <th>Tgl. Permohonan</th>
              <th>Tgl. Verdok</th>
              <th v-if="tipe == 'Swasta'">Tgl. Berlaku Tagihan</th>
              <th v-if="tipe == 'Swasta'">Status Tagihan</th>
              <th>PIC Pentek</th>
              <th style="text-align: center">Unduh File</th>
              <!-- <th>File Surat Tugas</th>
                        <th>File Undangan</th>
                        <th>File BA</th>
                        <th>File Memo</th> -->
              <th class="all">Aksi</th>
            </tr>
            <!-- <tr>
                        <th>Bukti Pembayaran</th>
                        <th>Surat Tugas</th>
                        <th>Undangan</th>
                        <th>BA</th>
                        <th>Memo</th>
                        <th>Persetujuan</th>
                    </tr> -->
          </thead>
          <tbody>
            <tr v-for="(data, index) in dataPermohonan" :key="data.id">
              <td class="sticky-col second-col">
                <span v-if="data.catatan_verdok !== null">{{ index + pagination.firstInPage }}</span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">{{ index + pagination.firstInPage }}</div>
                </span>
              </td>

              <td>
                <span class="badge rounded-pill bg-success" style="font-size: 10px; font-weight: normal"
                  v-if="data.nomor_permohonan != null">{{ data.nomor_permohonan }}</span>
                <span class="badge rounded-pill bg-danger" style="
                      font-size: 10px;
                      font-weight: normal;
                      background-color: #ff6e7c !important;
                    " v-else>Belum Ada</span>
              </td>
              <td style="word-wrap: break-word;min-width: 200px;max-width: 200px;white-space:normal;">{{
                data.instansi_pemohon }}</td>

              <td>
                <span v-if="data.catatan_verdok !== null">{{
                  data.jenis_kegiatan
                  }}</span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ data.jenis_kegiatan }}
                  </div>
                </span>
              </td>
              <td>
                <span v-if="data.catatan_verdok !== null">{{
                  data.nama_perairan
                  }}</span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ data.nama_perairan }}
                  </div>
                </span>
              </td>
              <td>{{ data.provinsi }}</td>
              <!-- <td>
              <span v-if="data.catatan_verdok !== null">{{
                data.status_verdok
              }}</span>
              <span v-else>
                <div
                  :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]"
                >
                  {{ data.status_verdok }}
                </div>
              </span>
            </td> -->
              <td>{{ data.status_permohonan }}</td>
              <td>{{ data.keterangan_status }}</td>
              <td>
                {{ format_date(data.tanggal_permohonan, "DD MMMM YYYY") }}
              </td>
              <td>
                {{
                  format_date(
                    data.tanggal_lolos_verifikasi_administrasi,
                    "DD MMMM YYYY"
                  )
                }}
              </td>
              <td v-if="tipe == 'Swasta'">
                <span v-if="data.status_tagihan_iii != null">
                  {{ format_date(data.tanggal_berlaku_hingga_tagihan_iii) }}
                </span>
                <span v-else-if="
                  data.status_tagihan_ii != null && data.status_tagihan_i != null
                ">
                  {{ format_date(data.tanggal_berlaku_hingga_tagihan_ii) }}
                </span>
                <span v-else>
                  {{ format_date(data.tanggal_berlaku_hingga_tagihan_i) }}
                </span>
              </td>
              <td v-if="tipe == 'Swasta'">
                <span v-if="data.status_tagihan_iii != null">
                  {{ data.status_tagihan_iii }}
                </span>
                <span v-else-if="
                  data.status_tagihan_ii != null && data.status_tagihan_i != null
                ">
                  {{ data.status_tagihan_ii }}
                </span>
                <span v-else>
                  {{ data.status_tagihan_i }}
                </span>
              </td>
              <td>
                {{ data.pic_name }}
              </td>
              <td>
                <FileDownloadNonberusaha :data="data" />
              </td>
              <td>
  <div class="d-flex flex-wrap align-items-center gap-1" style="max-width: 180px;">
    <!-- Detail -->
    <b-button
      size="sm"
      variant="info"
      title="Detail"
      class="text-white"
      @click="$router.push('/app/nonberusaha/detail-perizinan/' + data.id)"
    >
      <i class="fa fa-eye"></i> Detail
    </b-button>

    <!-- Tracking -->
    <b-button
      size="sm"
      variant="primary"
      @click="$emit('loadProgress', data.id)"
    >
      <i class="fa fa-search"></i> Tracking
    </b-button>

    <!-- Pentek -->
    <b-button
      v-if="
        (data.status_permohonan == 'Menunggu Jadwal Penilaian Teknis' ||
          data.status_permohonan == 'Penilaian Teknis' ||
          data.status_permohonan === 'Tim Teknis Pembuatan Berita Acara Hasil Penilaian Teknis') &&
        (!data.ttd_ba_vertek_1_status &&
          !data.ttd_ba_vertek_2_status &&
          !data.ttd_ba_vertek_4_status)
      "
      size="sm"
      variant="secondary"
      @click="$router.push({ path: '/app/nonberusaha/detail-verifikasi-teknis/' + data.id, query: { type: tipe } })"
    >
      <i class="fa fa-folder-open-o"></i> Pentek
    </b-button>

    <!-- BA -->
    <b-button
      v-if="
        (data.status_permohonan == 'Penilaian Teknis' ||
          data.status_permohonan === 'Tim Teknis Pembuatan Berita Acara Hasil Penilaian Teknis') &&
        (!data.ttd_ba_vertek_1_status &&
          !data.ttd_ba_vertek_2_status &&
          !data.ttd_ba_vertek_4_status)
      "
      size="sm"
      variant="primary"
      @click="$router.push({ path: '/app/nonberusaha/ba/' + data.id, query: { type: tipe } })"
    >
      <i class="fa fa-tasks"></i> BA
      <span v-if="data.catatan_ba_direktur != null" class="badgeku">!</span>
    </b-button>

    <!-- Finalisasi BA -->
    <b-button
      v-else-if="
        data.ttd_ba_vertek_1_status === true &&
        data.ttd_ba_vertek_2_status === true &&
        data.ttd_ba_vertek_3_status === true &&
        data.ttd_ba_vertek_4_status === true &&
        data.nomor_ba_vertek == null
      "
      size="sm"
      variant="primary"
      @click="idpermohonan = data.id; $bvModal.show('modal-final-ba');"
    >
      <i class="fa fa-tasks"></i> Finalisasi BA
    </b-button>

    <!-- BA Penolakan -->
    <b-button
      v-if="canBAPenolakan(data)"
      size="sm"
      variant="danger"
      class="text-white"
      @click="openBAPenolakan(data)"
    >
      <i class="fa fa-file-text"></i> BA Penolakan
    </b-button>

    <!-- Finalisasi BA Penolakan -->
    <b-button
      v-else-if="canShowFinalisasiBAPenolakan(data)"
      size="sm"
      variant="primary"
      @click="openModalFinalisasiBAPenolakan(data)"
    >
      <i class="fa fa-tasks"></i> Finalisasi BA Penolakan
    </b-button>
  </div>
</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between mt-4">
        <div>
          <template v-if="pagination.total">
            Menampilkan {{ pagination.firstInPage }} sampai {{ pagination.currentPage !== pagination.lastPage ?
              pagination.limit * pagination.currentPage : pagination.total }} dari {{ pagination.total }} data
          </template>
        </div>
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'first' })">
                <span aria-hidden="true">Awal</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'prev' })">
                <span aria-hidden="true">Sebelumnya</span>
              </a>
            </li>
            <li v-for="i in pagination.pageNumber" class="page-item">
              <a :class="['page-link', { 'active': i === `${pagination.currentPage}` }]" href="#"
                @click="changePage({ page: i })">{{ i }}</a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'next' })">
                <span aria-hidden="true">Selanjutnya</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'last' })">
                <span aria-hidden="true">Akhir</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- modal Final BA -->
    <b-modal body-class="bg-white" id="modal-final-ba" title="Finalisasi Berita Acara" cancel-title="Close"
      ok-title="Accept" size="md" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Nomor Berita Acara: *">
              <input :class="{ 'form-control': true }" type="txt" v-validate="'required'" name="Nomor Berita Acara"
                v-model="nomorBA" />
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="finalBA">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal nomor memo -->
    <b-modal body-class="bg-white" id="modal-final-memo" title="Finalisasi Memo" cancel-title="Close" ok-title="Accept"
      size="md" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Nomor KKP: *">
              <input :class="{ 'form-control': true }" type="txt" v-validate="'required'" name="Nomor KKP"
                v-model="dataPerDokumen.nomor_kkp" />
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="finalMemo">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal memo -->
    <b-modal body-class="bg-white" id="modal-memo" size="xl" title="Memo Persetujuan" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row v-if="this.dataPerDokumen.status_pembuatan_memorandum != null">
          <b-col v-if="
            this.dataPerDokumen.status_pembuatan_memorandum.includes(
              'Catatan'
            )
          " md="12">
            <b-alert show variant="info">
              <span><span class="fw-semi-bold">Info:</span> Terdapat Catatan
                Perbaikan.
                <a type="button" data-toggle="modal" data-target=".catatan"
                  class="btn btn-default btn-xs float-end me-1" @click="getCatatanMemo(dataPerDokumen.id)">Lihat
                  Catatan</a></span>
            </b-alert>
          </b-col>
        </b-row>
        <legend><strong>Memo 1</strong></legend>
        <b-row>
          <b-col md="4">
            <b-form-group label="Paraf 1 Memo : *">
              <v-select id="default-select" v-model="dataPerDokumen.paraf_1_memo_1" :options="dataTTD"
                :reduce="(user) => user.id_user" v-validate="'required'" name="Paraf 1 Memo"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 1 Memo') }" label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Paraf 1 Memo')">
                {{ errors.first("form-1.Paraf 1 Memo") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 2 Memo : *">
              <v-select id="default-select" v-model="dataPerDokumen.paraf_2_memo_1" :options="dataTTD"
                v-validate="'required'" name="Paraf 2 Memo" :class="{ 'is-invalid': errors.has('form-1.Paraf 2 Memo') }"
                :reduce="(user) => user.id_user" label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Paraf 2 Memo')">
                {{ errors.first("form-1.Paraf 2 Memo") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Tandatangan Memo : *">
              <v-select id="default-select" v-model="dataPerDokumen.ttd_memo_1" :options="dataTTD"
                v-validate="'required'" name="Tandatangan Memo"
                :class="{ 'is-invalid': errors.has('form-1.Tandatangan Memo') }" :reduce="(user) => user.id_user"
                label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Tandatangan Memo')">
                {{ errors.first("form-1.Tandatangan Memo") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <legend><strong>Memo 2</strong></legend>
        <b-row>
          <b-col md="4">
            <b-form-group label="Paraf 1 Memo : *">
              <v-select id="default-select" v-model="dataPerDokumen.paraf_1_memo_2" :options="dataTTD"
                v-validate="'required'" name="Paraf 1 Memo" :class="{ 'is-invalid': errors.has('form-1.Paraf 1 Memo') }"
                :reduce="(user) => user.id_user" label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Paraf 1 Memo')">
                {{ errors.first("form-1.Paraf 1 Memo") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 2 Memo : *">
              <v-select id="default-select" v-model="dataPerDokumen.paraf_2_memo_2" :options="dataTTD"
                v-validate="'required'" name="Paraf 2 Memo" :class="{ 'is-invalid': errors.has('form-1.Paraf 2 Memo') }"
                :reduce="(user) => user.id_user" label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Paraf 2 Memo')">
                {{ errors.first("form-1.Paraf 2 Memo") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 3 Memo : *">
              <v-select id="default-select" v-model="dataPerDokumen.paraf_3_memo_2" :options="dataTTD"
                v-validate="'required'" name="Paraf 3 Memo" :class="{ 'is-invalid': errors.has('form-1.Paraf 3 Memo') }"
                :reduce="(user) => user.id_user" label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Paraf 3 Memo')">
                {{ errors.first("form-1.Paraf 3 Memo") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Tandatangan Memo : *">
              <v-select id="default-select" v-model="dataPerDokumen.ttd_memo_2" :options="dataTTD"
                v-validate="'required'" name="Tandatangan Memo"
                :class="{ 'is-invalid': errors.has('form-1.Tandatangan Memo') }" :reduce="(user) => user.id_user"
                label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Tandatangan Memo')">
                {{ errors.first("form-1.Tandatangan Memo") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <legend><strong>Putusan</strong></legend>
        <b-row>
          <b-col md="4">
            <b-form-group label="Paraf 1 Putusan : *">
              <v-select id="default-select" v-model="dataPerDokumen.paraf_1_putusan" :options="dataTTD"
                v-validate="'required'" name="Paraf 1 Putusan"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 1 Putusan') }" :reduce="(user) => user.id_user"
                label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Paraf 1 Putusan')">
                {{ errors.first("form-1.Paraf 1 Putusan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 2 Putusan : *">
              <v-select id="default-select" v-model="dataPerDokumen.paraf_2_putusan" :options="dataTTD"
                v-validate="'required'" name="Paraf 2 Putusan"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 2 Putusan') }" :reduce="(user) => user.id_user"
                label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Paraf 2 Putusan')">
                {{ errors.first("form-1.Paraf 2 Putusan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 3 Putusan : *">
              <v-select id="default-select" v-model="dataPerDokumen.paraf_3_putusan" :options="dataTTD"
                v-validate="'required'" name="Paraf 3 Putusan"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 3 Putusan') }" :reduce="(user) => user.id_user"
                label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Paraf 3 Putusan')">
                {{ errors.first("form-1.Paraf 3 Putusan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 4 Putusan : *">
              <v-select id="default-select" v-model="dataPerDokumen.paraf_4_putusan" :options="dataTTD"
                v-validate="'required'" name="Paraf 4 Putusan"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 4 Putusan') }" :reduce="(user) => user.id_user"
                label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Paraf 4 Putusan')">
                {{ errors.first("form-1.Paraf 4 Putusan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Tandatangan Putusan : *">
              <v-select id="default-select" v-model="dataPerDokumen.ttd_putusan" :options="dataTTD"
                v-validate="'required'" name="Tandatangan Putusan" :class="{
                  'is-invalid': errors.has('form-1.Tandatangan Putusan'),
                }" :reduce="(user) => user.id_user" label="nama_lengkap" />
              <span class="text-danger" v-if="errors.has('form-1.Tandatangan Putusan')">
                {{ errors.first("form-1.Tandatangan Putusan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="File Map Memo: ">
              <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." plain
                class="form-control" v-model="dataPerDokumen.file_map_memo" v-validate="'required'" name="File Map Memo"
                accept="image/*" :class="{ 'is-invalid': errors.has('form-1.File Map Memo') }"></b-form-file>
              <span class="text-danger" v-if="errors.has('form-1.File Map Memo')">
                {{ errors.first("form-1.File Map Memo") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="onSubmit">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal catatan memo -->
    <div class="modal fade catatan" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content" style="background-color: white">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Catatan</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: white">
            <div>
              <table id="example2" class="table" style="width: 100%">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Nama Pengirim</th>
                    <!-- <th>Jabatan Pengirim</th> -->
                    <th>Status</th>
                    <th>Catatan</th>
                    <th>Tanggal</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in dataCatatanMemo" :key="data.id">
                    <td></td>
                    <td>{{ data.nama_pengirim }}</td>
                    <!-- <td>
                                                {{data.jabatan_pengirim}}
                                            </td> -->
                    <td>
                      {{ data.status }}
                    </td>
                    <td>
                      <div v-html="data.isi_catatan"></div>
                    </td>
                    <td>
                      {{
                        new Date(data.createdAt).toLocaleDateString(
                          "id-ID",
                          options
                        )
                      }}
                      <br />
                      {{ new Date(data.createdAt).toLocaleTimeString() }}
                    </td>
                    <td>
                      <div>
                        <button data-toggle="modal" data-target="#modal-catatan" @click="getPerCatatanMemo(data.id)"
                          style="margin: 5px" class="btn btn-secondary">
                          <i class="fa fa-eye"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- modal detail catatan -->
    <div class="modal fade" id="modal-catatan" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Detail Catatan {{ detailCatatan.nama_pengirim }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: white">
            <form ref="form" @submit.stop.prevent="tambahcatatan">
              <b-col md="12">
                <div class="form-group">
                  <b-form-group label="Detail Catatan :">
                    <!-- <b-form-textarea
                                                id="textarea-formatter"
                                                v-html="detailCatatan.isi_catatan "
                                                
                                            ></b-form-textarea> -->
                    <ckeditor :editor="wygEditor" v-model="detailCatatan.isi_catatan"></ckeditor>
                  </b-form-group>
                </div>
              </b-col>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal body-class="bg-white" id="modal-bayar" title="Upload Pembayaran" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="File Bukti Pembayaran: *" label-for="username">
              <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." plain
                class="form-control" v-model="dataPerDokumen.bukti_pembayaran" accept=".pdf"></b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="onSubmitPembayaran">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

     <BAPenolakan v-model="showModalBA" :row-data="selectedRow" @submit="handleSaveBAPenolakan" />
    <FinalisasiBAPenolakan v-model="showModalBAPenolakan" :row-data="selectedRow"
      @submit="handleFinalisasiBAPenolakan" />
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import vSelect from "vue-select";
import axios from "axios";
import VueLoading from "vuejs-loading-plugin";
import Swal from "sweetalert2";
import * as xlsx from "xlsx";
import FileDownloadNonberusaha from "../../Components/FileDownloadNonberusaha.vue";
import BAPenolakan from "../../Components/BAPenolakan.vue";
import FinalisasiBAPenolakan from "../../Components/FinalisasiBAPenolakan.vue";

// using default options
Vue.use(VueLoading);

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: "Loading", // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: "rgb(255,255,255)", // set custom background
  classes: ["myclass"], // array, object or string
});
export default {
  components: { ClassicEditor, vSelect, FileDownloadNonberusaha, BAPenolakan, FinalisasiBAPenolakan },
  data() {
    return {
      fields: [
        "no",
        { key: "nama_pemohon", sortable: true },
        { key: "nomor_permohonan", sortable: true },
        { key: "jenis_kegiatan", sortable: true },
        {
          key: "status_verdok",
          label: "Status Verifikasi Dokumen",
          sortable: true,
        },
        {
          key: "status_vertek",
          label: "Status Penilaian Teknis",
          sortable: true,
        },
        { key: "tanggal_pada_permohonan", label: "Tanggal Permohonan" },
        { key: "tanggal_berlaku", label: "Tanggal Berlaku Tagihan" },
        { key: "tagihan", label: "Tagihan" },
        { key: "file_ba", label: "File BA" },
        { key: "file_memo", label: "File Memo" },
        "Aksi",
      ],
      optionsDatatable: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: "", count: "", limit: "" },
        columnsClasses: { id: "width-100" },
        skin: "table table-striped",
        sortIcon: {
          base: "fa text-muted",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
      },

      // currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      dataPerDokumen: [],
      wygEditor: ClassicEditor,
      dataTTD: [],
      dataPermohonan: [],
      dataCatatanMemo: [],
      nomorBA: null,
      detailCatatan: [],
      idpermohonan: null,
      selectedFile: null,

      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      search: {
        field: "nomor_permohonan",
        value: "",
      },
      sort: {
        field: "tanggal_permohonan",
        direction: "DESC",
      },
      debounceTerm: null,
      show: false,
      showModalBA: false,
      showModalBAPenolakan: false,
      selectedRow: null
    };
  },
  props: {
    itemsWithNumber: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataJenisProyek: {
      type: Array,
      default: () => {
        return [];
      },
    },
    user: {
      // type: Array,
      default: () => {
        return [];
      },
    },
    baseapi: String,
    dataRisiko: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataSkalaUsaha: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataStatusVerdok: {
      type: Array,
      default: () => {
        return [];
      },
    },
    rows: Number,
    tipe: String,
    totalRows: Number,
    currentPage: Number,
  },
  mounted() {
    this.getdata();
    this.getDataTTD();
  },
  watch: {
    search: {
      handler: function (val) {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.getdata();
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.pagination.currentPage = 1
        this.getdata();
      },
      deep: true,
    },
  },
  methods: {
    onFiltered(data) {
      this.$emit("onFiltered", data);
    },
    pilihModal() {
      this.$emit("pilihModal");
    },
    deleteDokumen(data) {
      this.$emit("deleteDokumen", data);
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD MMMM YYYY");
      }
    },

    async getdata() {
      $("#nonberusahaPICUPT").DataTable().destroy();
      return this.loadData();
    },

    finalBA() {
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-final-ba");
          });
          this.$loading(true);
          axios
            .put(
              this.baseapi +
              "api/permohonan_nonberusaha/generate_ba/" +
              this.idpermohonan,
              {
                nomor_ba_vertek: this.nomorBA,
              },
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil Disimpan");
              this.getdata();
              this.dataPerDokumen = [];
              //   this.dataUser = []

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    finalMemo() {
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-final-memo");
          });
          axios
            .post(
              this.baseapi +
              "api/permohonan_nonberusaha/" +
              this.dataPerDokumen.id,
              {
                // nomor_kkp: this.dataPerDokumen.nomor_kkp,
                status_pembuatan_memorandum: "Selesai",
              },
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Disimpan");
              this.getdata();
              this.dataPerDokumen = [];
              //   this.dataUser = []

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment("DD MMMM YYYY");

        var t = $("#nonberusahaPICUPT").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // stateSave: true,
          // order: [[8, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: {
            left: 3,
            right: 1,
          },
          scrollX: true,
          dom: "Bfrtip",
          // fnRowCallback: function (
          //   nRow,
          //   aData,
          //   iDisplayIndex,
          //   iDisplayIndexFull
          // ) {
          //   //debugger;
          //   var index = iDisplayIndexFull + 1;
          //   $("td:first", nRow).html(index);
          //   return nRow;
          // },
          columnDefs: [
            // { type: 'date-dd-mmm-yyyy', targets: 8 },
            {
              targets: 0,
              render: function (data, type, row, meta) {
                // console.log(meta.row);
                // console.log(type == "export" ? meta.row : data);
                return type == "export" ? meta.row + 1 : data;
              },
            },
          ],
          buttons: [
            // 'excel', 'pdf',
            // {
            //   extend: "excelHtml5",
            //   title: "DATA PEMOHON",
            //   text: '<i class="fa fa-file-text-o"></i> Excel',
            //   className: "btn btn-success",
            //   exportOptions: {
            //     columns: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            //     orthogonal: "export",
            //     // format: {
            //     //     header: function ( data, columnIdx ) {
            //     //         if(columnIdx==7 || columnIdx==8 || columnIdx==9){
            //     //         return 'Aktivitas ' + data;
            //     //         }
            //     //         else if(columnIdx==10 || columnIdx==11){
            //     //           return 'Verifikasi Dokumentatif ' + data;
            //     //         }
            //     //         else if(columnIdx==12 || columnIdx==13){
            //     //           return 'Verifikasi Lapangan ' + data;
            //     //         }
            //     //         else if(columnIdx==14 || columnIdx==15){
            //     //           return 'File BA ' + data;
            //     //         }
            //     //         else if(columnIdx==16 || columnIdx==17 || columnIdx==18){
            //     //           return 'Predikat ' + data;
            //     //         }
            //     //         else{
            //     //           return data;
            //     //         }
            //     //     },
            //     //     body: function(data, row, column, node) {
            //     //         data = $('<p>' + data + '</p>').text();
            //     //         return data.replace(',', '.');
            //     //     },
            //     // }
            //   },
            //   filename: function () {
            //     var today = new Date();
            //     // var n = d.getTime();
            //     var date =
            //       today.getFullYear() +
            //       "-" +
            //       (today.getMonth() + 1) +
            //       "-" +
            //       today.getDate();

            //     return "Data Pemohon " + date;
            //   },
            // },
          ],
        });
        // t.on("order.dt search.dt", function () {
        //   t.column(0, { search: "applied", order: "applied" })
        //     .nodes()
        //     .each(function (cell, i) {
        //       cell.innerHTML = i + 1;
        //     });
        // }).draw();
      }, 300);
    },

    loadData() {
      this.show = true
      this.dataPermohonan = []
      // const api = `api/permohonan_nonberusaha/dataTable?page=${this.pagination.currentPage}&filter=tipe_pemohon,=,${this.tipe};pic_id,=,${this.user.id};${this.search.field},like,${this.search.value}`
      const api = `api/permohonan_nonberusaha/dataTable` +
        `?page=${this.pagination.currentPage}` +
        `&filter=tipe_pemohon,=,${this.tipe};pic_id,=,${this.user.id}${this.search.value !== '' ? `;${this.search.field},${this.search.field === 'tanggal_permohonan' || this.search.field === 'tanggal_lolos_verifikasi_administrasi' ? '>=' : 'like'},${this.search.value}` : ''}` +
        `&sort=${this.sort.field},${this.sort.direction}`
      // "api/permohonan_nonberusaha?filter=tipe_pemohon,=,"+this.tipe+";pic_id,=,"+this.user.id,
      axios
        .get(
          this.baseapi + api,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          // console.log(response);
          const data = response.data
          this.pagination.limit = data.limit
          this.pagination.total = data.total
          this.pagination.firstInPage = (this.pagination.currentPage - 1) * data.limit + 1
          this.pagination.lastPage = Math.ceil(data.total / data.limit)
          this.setPagination()
          this.dataPermohonan = response.data.data;
          for (let index = 0; index < this.dataPermohonan.length; index++) {
            Vue.set(this.dataPermohonan[index], "selectedFile", null);
          }
          this.initDatatable();
        })
        .catch((error) => {
          console.log(error);
          return error;
        }).finally(() => {
          this.show = false
        });
    },

    setPagination() {
      this.$router.replace({
        path: this.$route.path,
        query: { page: this.pagination.currentPage },
      }).catch((err) => { })
      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        if (config.page === '...') return
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getdata()
      $('html,body').scrollTop(1000)
    },

    getBayar(id) {
      axios
        .get(this.baseapi + "api/permohonan_nonberusaha/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPerDokumen = response.data.data;
          this.$bvModal.show("modal-bayar");
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    onSubmitPembayaran() {
      console.log("cok");
      this.$nextTick(() => {
        this.$bvModal.hide("modal-bayar");
      });
      this.$loading(true);
      let formData = new FormData();
      formData.append("bukti_pembayaran", this.dataPerDokumen.bukti_pembayaran);
      axios
        .post(
          this.baseapi + "api/permohonan_nonberusaha/" + this.dataPerDokumen.id,
          formData,
          {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          this.$loading(false);
          this.$toasted.success("Berhasil Disimpan");
          this.dataPerDokumen = [];
          this.getdata();
          return res;
        })
        .catch((err) => {
          this.$loading(false);
          console.log(err);
          this.$toasted.error(err.response.data.message);
          // this.$bvModal.hide('modal-pembayaran')
          return err;
        });
    },

    getDetailPerDokumen(id) {
      axios
        .get(this.baseapi + "api/permohonan_nonberusaha/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPerDokumen = response.data.data;
          if (this.dataPerDokumen.status_pembuatan_memorandum != null) {
            if (
              this.dataPerDokumen.status_pembuatan_memorandum.includes(
                "Menunggu"
              )
            ) {
              Swal.fire({
                icon: "info",
                title: this.dataPerDokumen.status_pembuatan_memorandum,
              });
            } else if (
              this.dataPerDokumen.status_pembuatan_memorandum.includes(
                "Catatan"
              )
            ) {
              // this.getCatatanMemo()
              Swal.fire({
                icon: "question",
                title: "Silahkan Pilih",
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: "Unduh Memo",
                denyButtonText: `Perbaikan Memo`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  window.open(
                    this.dataPerDokumen.file_konsep_memorandum,
                    "_blank"
                  );
                } else if (result.isDenied) {
                  this.$bvModal.show("modal-memo");
                }
              });
            } else if (
              this.dataPerDokumen.status_pembuatan_memorandum.includes(
                "Sudah ditandatangani"
              )
            ) {
              this.$bvModal.show("modal-final-memo");
            } else if (
              this.dataPerDokumen.status_pembuatan_memorandum == "Selesai"
            ) {
              Swal.fire({
                icon: "info",
                title: "Unduh Surat Tugas",
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: "Unduh",
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  window.open(
                    this.dataPerDokumen.file_final_memorandum,
                    "_blank"
                  );
                }
              });
            }
          } else {
            this.$bvModal.show("modal-memo");
          }
          //   if (this.dataPerDokumen.status_pembuatan_memorandum.includes("Menunggu") ) {
          //         Swal.fire({
          //             icon: 'info',
          //             title: this.dataPerDokumen.status_pembuatan_memorandum ,
          //         })
          //     } else if (this.dataPerDokumen.status_pembuatan_memorandum.includes("Catatan") ) {
          //         this.getCatatanSurat()
          //         Swal.fire({
          //             icon: 'question',
          //             title: 'Silahkan Pilih',
          //             showDenyButton: true,
          //             showCancelButton: true,
          //             confirmButtonText: 'Unduh Memo',
          //             denyButtonText: `Perbaikan Memo`,
          //             }).then((result) => {
          //                 /* Read more about isConfirmed, isDenied below */
          //                 if (result.isConfirmed) {
          //                     window.open(this.dataPerDokumen.file_konsep_memorandum, '_blank');
          //                 } else if (result.isDenied) {
          //                     this.$bvModal.show('modal-memo')
          //                 }
          //             })
          //     } else if(this.dataPerDokumen.status_pembuatan_memorandum.includes("Sudah ditandatangani")){
          //         this.$bvModal.show('modal-final-memo')
          //     } else if (this.dataPerDokumen.status_pembuatan_memorandum  == 'Selesai'){
          //         Swal.fire({
          //             icon: 'info',
          //             title: 'Unduh Surat Tugas',
          //             showDenyButton: false,
          //             showCancelButton: false,
          //             confirmButtonText: 'Unduh',
          //             }).then((result) => {
          //             /* Read more about isConfirmed, isDenied below */
          //                 if (result.isConfirmed) {
          //                     window.open(this.dataPerDokumen.file_final_memorandum, '_blank');
          //                 }
          //             })
          //     }
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getCatatanMemo(id) {
      $("#example2").DataTable().destroy();
      axios
        .get(this.baseapi + "api/catatan_memo?filter=id_permohonan,=," + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataCatatanMemo = response.data.data;
          this.initDatatable2();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getPerCatatanMemo(id) {
      axios
        .get(this.baseapi + "api/catatan_memo/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.detailCatatan = [];
          this.detailCatatan.nama_pengirim = response.data.data.nama_pengirim;
          if (response.data.data.isi_catatan == null) {
            this.detailCatatan.isi_catatan = "";
          } else {
            this.detailCatatan.isi_catatan = response.data.data.isi_catatan;
          }
          console.log(this.detailCatatan);
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    initDatatable2() {
      setTimeout(() => {
        var t = $("#example2").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // order: [[0, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: {
            left: 2,
            right: 1,
          },
          scrollX: true,
          // dom: 'Bfrtip',
          // "fnRowCallback": function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          //     //debugger;
          //     var index = iDisplayIndexFull + 1;
          //     $("td:first", nRow).html(index);
          //     return nRow;
          //   },
          //   columnDefs: [{
          //     targets: 0,
          //     render: function(data, type, row, meta) {
          //     console.log(meta.row);
          //     console.log(type == 'export'? meta.row : data);
          //       return type == 'export'? meta.row + 1 : data;
          //     }
          //   }],
        });

        // t.on( 'click', 'button', function (e) {
        //     var closestRow = $(this).closest('tr');
        //     var data = t.row( $(this).parents(closestRow)).data();
        //     alert(data[0])
        //     // alert( t.cell( $(this).closest('tr').prev('tr'), $(this).attr('data-dtr-index') ).data() );
        // e.stopPropagation();

        // } );
        t.on("order.dt search.dt", function () {
          t.column(0, { search: "applied", order: "applied" })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
        }).draw();
      }, 300);
    },

    getDataTTD() {
      axios
        .get(this.baseapi + "api/tandatangan", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataTTD = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    onSubmit() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-memo");
      });
      this.$loading(true);
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          let formData = new FormData();
          formData.append("paraf_1_memo_1", this.dataPerDokumen.paraf_1_memo_1);
          formData.append("paraf_2_memo_1", this.dataPerDokumen.paraf_2_memo_1);
          formData.append("ttd_memo_1", this.dataPerDokumen.ttd_memo_1);
          formData.append("paraf_1_memo_2", this.dataPerDokumen.paraf_1_memo_2);
          formData.append("paraf_2_memo_2", this.dataPerDokumen.paraf_2_memo_2);
          formData.append("paraf_3_memo_2", this.dataPerDokumen.paraf_3_memo_2);
          formData.append("ttd_memo_2", this.dataPerDokumen.ttd_memo_2);
          formData.append(
            "paraf_1_putusan",
            this.dataPerDokumen.paraf_1_putusan
          );
          formData.append(
            "paraf_2_putusan",
            this.dataPerDokumen.paraf_2_putusan
          );
          formData.append(
            "paraf_3_putusan",
            this.dataPerDokumen.paraf_3_putusan
          );
          formData.append(
            "paraf_4_putusan",
            this.dataPerDokumen.paraf_4_putusan
          );
          formData.append("ttd_putusan", this.dataPerDokumen.ttd_putusan);
          formData.append("file_map_memo", this.dataPerDokumen.file_map_memo);
          axios
            .post(
              this.baseapi +
              "api/permohonan_nonberusaha/" +
              this.dataPerDokumen.id,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil Membuat Memo");
              this.getdata();
              this.dataPerDokumen = [];

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    //BA Penolakan
    canBAPenolakan(row) {
      return row.status_tagihan_iii === 'Menunggu Pembayaran' && row.status_permohonan == 'Menunggu Pembayaran PNBP' && this.user?.role === 'pic_upt';
    },

    openBAPenolakan(row) {
      this.selectedRow = row
      this.showModalBA = true
    },

    async handleSaveBAPenolakan(payload) {
      // Tampilkan loading indikator untuk mencegah double submit
      Swal.fire({
        title: 'Menyimpan...',
        text: 'Mohon tunggu sebentar',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      try {
        payload.status_tagihan_iii = 'Tidak Dibayarkan'
        const { id, ...bodyData } = payload

        await axios.post(`${this.baseapi}api/permohonan_nonberusaha/updatePembayaran/${id}`, bodyData, {
          headers: {
            Authorization: `Bearer ${this.user?.accessToken}`,
          },
        })

        Swal.fire({
          icon: 'success',
          title: 'Berhasil',
          text: 'Berhasil submit BA Penolakan',
        })

        this.showModalBA = false

        this.loadData()
      } catch (error) {
        console.error('Gagal menyimpan BA Penolakan:', error)

        const errorMessage =
          error.response?.data?.message || 'Terjadi kesalahan sistem saat menyimpan data'

        Swal.fire({
          icon: 'error',
          title: 'Gagal',
          text: errorMessage,
        })
      }
    },

    openModalFinalisasiBAPenolakan(row) {
      this.selectedRow = row // Data dari tabel/list Anda
      this.showModalBAPenolakan = true
    },

    async handleFinalisasiBAPenolakan(payload) {
      // 1. Tampilkan indikator loading untuk mencegah double submit
      Swal.fire({
        title: 'Finalisasi BA',
        text: 'Mohon tunggu sebentar',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      try {
        // 2. Petakan payload agar sesuai dengan kebutuhan API
        const bodyData = {
          nomor_ba_tidak_bayar: payload.nomor_ba_penolakan || payload.nomor_ba_tidak_bayar,
        }

        // 3. Panggil API generate BA Tidak Bayar
        const response = await axios.put(
          `${this.baseapi}api/permohonan_nonberusaha/generate_ba_tidak_bayar/${payload.id}`,
          bodyData,
          {
            headers: {
              Authorization: `Bearer ${this.user?.accessToken}`,
            },
          }
        )

        // 4. Berikan notifikasi sukses
        Swal.fire({
          icon: 'success',
          title: 'Berhasil',
          text: response.data?.message || 'Berhasil menyimpan BA Penolakan',
        })

        // 5. Tutup modal
        this.showModalBAPenolakan = false

        this.loadData()

      } catch (error) {
        console.error('Gagal menyimpan BA Penolakan:', error)

        const errorMessage =
          error.response?.data?.message || 'Terjadi kesalahan sistem saat menyimpan data'

        Swal.fire({
          icon: 'error',
          title: 'Gagal',
          text: errorMessage,
        })
      }
    },
    isAllTTDBAPenolakan(row) {
      return row.ttd_ba_tidak_bayar_1_status === true &&
        row.ttd_ba_tidak_bayar_2_status === true &&
        row.ttd_ba_tidak_bayar_4_status === true;
    },
    canShowFinalisasiBAPenolakan(row) {
      return this.isAllTTDBAPenolakan(row) && (row.nomor_ba_tidak_bayar == null || row.file_ba_tidak_bayar == null);
    },

    exportData() {
      this.$loading(true);
      const api = `api/permohonan_nonberusaha` +
        `?sort=${this.sort.field},${this.sort.direction}` +
        `&filter=tipe_pemohon,=,${this.tipe};pic_id,=,${this.user.id}${this.search.value !== '' ? `;${this.search.field},${this.search.field === 'tanggal_proses' || this.search.field === 'tanggal_pada_permohonan' ? '>=' : 'like'},${this.search.value}` : ''}`
      axios.get(this.baseapi + api, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then((res) => {
        const worksheetData = [
          ['Data Pemohon'],
          ['No', 'Nomor Pemohon', 'Instansi Pemohon', 'Jenis Kegiatan', 'Nama Perairan', 'Provinsi', 'Status Verdok', 'Status Permohonan', 'Tgl. Permohonan', 'Tgl. Verdok', 'PIC Pentek']
        ]
        const merge = [{ s: { c: 0, r: 0 }, e: { c: worksheetData[1].length - 1, r: 0 }, }]
        res.data.data.map((d, i) => {
          worksheetData.push([
            i + 1,
            d.nomor_permohonan,
            d.instansi_pemohon,
            d.jenis_kegiatan,
            d.nama_perairan,
            d.provinsi,
            d.status_verdok,
            d.status_permohonan,
            d.tanggal_permohonan,
            d.tanggal_lolos_verifikasi_administrasi,
            d.pic_name,
          ])
        })

        const workbook = xlsx.utils.book_new();
        const worksheet = xlsx.utils.aoa_to_sheet(worksheetData);
        worksheet["!merges"] = merge;
        xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const d = new Date();
        xlsx.writeFile(workbook, `Data Pemohon ${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}.xlsx`);
      }).catch((err) => {
        Swal.fire('Gagal', 'Gagal mengekspor data', 'error')
      }).finally(() => {
        this.$loading(false);
      })
    },
  },
};
</script>